import { TimeStepCumulativeRainfallDTO } from './TimeStepCumulativeRainfallDTO'
import { TimeStepCumulativeRainfallRaw } from './TimeStepCumulativeRainfallRaw'

export class TimeStepCumulativeRainfallDTOFactory {
  static fromRaw(raw: TimeStepCumulativeRainfallRaw): TimeStepCumulativeRainfallDTO {
    const timestamp = raw.timestamp

    const cumRainfall = raw.cumulative_rainfall

    return new TimeStepCumulativeRainfallDTO(
      timestamp as string,

      cumRainfall
        ? cumRainfall.map((cr) => ({
            cumulativeRainfall: cr.cumulative_rainfall,
            maxIntensity: cr.max_intensity,
          }))
        : undefined,
    )
  }
}
